export const requestApp = (type: string, data?: any) => {
    if (!window.ReactNativeWebView) return; // 웹뷰가 아닐 경우에는 return
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type, data: data || {} }))
}

export const APP_TO_WEB = {
    INSET_INFO: "INSET_INFO",
    DEVICE_INFO: "DEVICE_INFO",
    // 지도 관련 응답
    PLACE_SEARCH_RESULT: "PLACE_SEARCH_RESULT",
    PLACE_EXPLORE_RESULT: "PLACE_EXPLORE_RESULT",
    GOOGLE_PLACE_SEARCH_RESULT: "GOOGLE_PLACE_SEARCH_RESULT",
    CURRENT_LOCATION_RESULT: "CURRENT_LOCATION_RESULT",
    TOKEN_REFRESH_RESULT: "TOKEN_REFRESH_RESULT",
    // 외부 앱(지도 등)에서 장소 공유 수신
    SHARED_PLACE: "SHARED_PLACE",
    // 이미지 선택 결과
    PICK_IMAGE_RESULT: "PICK_IMAGE_RESULT",
    SAVE_IMAGE_RESULT: "SAVE_IMAGE_RESULT",
    SHARE_IMAGE_RESULT: "SHARE_IMAGE_RESULT",
    // 푸시 알림 탭 → 화면 이동
    NAVIGATE: "NAVIGATE",
}

export const WEB_TO_APP = {
    LOGS: "LOGS",
    MSG_READY : "MSG_READY",
    SEND_TOKEN: "SEND_TOKEN",
    SAVE_USER_INFO: "SAVE_USER_INFO",
    CLEAR_USER_INFO: "CLEAR_USER_INFO",
    // 로그아웃 — 네이티브 토큰/유저정보 + 위치추적 일괄 정리
    CLEAR_AUTH: "CLEAR_AUTH",
    OPEN_POPUP: "OPEN_POPUP",
    CLOSE_POPUP: "CLOSE_POPUP",
    // 지도 관련 요청
    OPEN_PLACE_SEARCH: "OPEN_PLACE_SEARCH",
    OPEN_MAP_VIEW: "OPEN_MAP_VIEW",
    OPEN_REALTIME_LOCATION: "OPEN_REALTIME_LOCATION",
    GET_CURRENT_LOCATION: "GET_CURRENT_LOCATION",
    // 토큰 갱신 요청 — 앱 안에서는 네이티브만 /auth/refresh 를 부른다
    REQUEST_TOKEN_REFRESH: "REQUEST_TOKEN_REFRESH",
    // 해외 장소 탐색 (네이티브 전체화면 지도)
    OPEN_PLACE_EXPLORE: "OPEN_PLACE_EXPLORE",
    // 여행 모임 숙박/장소 선택 — 국가 제한 없는 Google Maps (해외 포함)
    OPEN_GOOGLE_PLACE_SEARCH: "OPEN_GOOGLE_PLACE_SEARCH",
    // 공유 기능 (OS 기본 Share Sheet)
    SHARE: "SHARE",
    // 이미지 선택 (갤러리/카메라)
    PICK_IMAGE: "PICK_IMAGE",
    // 사진 저장 — 웹은 CORS 때문에 이미지 바이트를 읽지 못합니다
    SAVE_IMAGE: "SAVE_IMAGE",
    // 사진 자체 공유 — RN Share 는 안드로이드에서 텍스트만 보냅니다
    SHARE_IMAGE: "SHARE_IMAGE",
    // 이미지 선택 (카메라 전용)
    PICK_IMAGE_CAMERA: "PICK_IMAGE_CAMERA",
    // 이미지 선택 (갤러리 전용)
    PICK_IMAGE_GALLERY: "PICK_IMAGE_GALLERY",
    // 채팅 푸시 알림 제거 (채팅방 진입 시 해당 room의 알림 trayee에서 제거)
    DISMISS_CHAT_NOTIFICATIONS: "DISMISS_CHAT_NOTIFICATIONS",
    // 위치 추적 제어
    SET_MEETING_SCHEDULE: "SET_MEETING_SCHEDULE",
    REMOVE_MEETING_SCHEDULE: "REMOVE_MEETING_SCHEDULE",
    CLEAR_MEETING_SCHEDULE: "CLEAR_MEETING_SCHEDULE",
    // 귀가 도우미 (Safe Return) — 모임 종료 후에도 BG location 유지
    SET_NATIVE_SAFE_RETURN_SESSION: "SET_NATIVE_SAFE_RETURN_SESSION",
    CLEAR_NATIVE_SAFE_RETURN_SESSION: "CLEAR_NATIVE_SAFE_RETURN_SESSION",
    GET_NATIVE_SAFE_RETURN_SESSIONS: "GET_NATIVE_SAFE_RETURN_SESSIONS",
    // 디버그 — 네이티브가 수집 중인 위치 정보 덤프 요청 (개발 전용)
    GET_LOCATION_DEBUG: "GET_LOCATION_DEBUG",
    // 외부 URL — OS 기본 브라우저로 열기 (iOS WKWebView 가 window.open 을 같은 뷰에 로드하는 문제 해결)
    OPEN_EXTERNAL_URL: "OPEN_EXTERNAL_URL",
    // 푸시 NAVIGATE 수신 확인 회신 (네이티브 race 방지 보조)
    NAVIGATE_ACK: "NAVIGATE_ACK",
}

/**
 * 외부 URL 을 OS 기본 브라우저에서 열기.
 * - 네이티브 앱: 브릿지로 위임 → Linking.openURL (Safari/Chrome)
 * - 일반 웹: window.open(_blank)
 * iOS WKWebView 에서 window.open 은 같은 뷰에 로드되어 back 동선이 끊기므로 이 헬퍼를 사용해야 함.
 */
export const openExternalUrl = (url: string) => {
    if (!url) return;
    if (isNativeApp()) {
        requestApp(WEB_TO_APP.OPEN_EXTERNAL_URL, { url });
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
};

// 팝업 열기 함수들
export const openNoticePopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/notice', title: '공지사항' });
}

export const openFaqPopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/faq', title: 'FAQ' });
}

export const openQnaPopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/qna', title: '의견보내기' });
}

export const openTermsPopup = (termsType?: string) => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: `/wiz-common/terms${termsType ? `?type=${termsType}` : ''}`, title: '약관' });
}

export const closePopup = () => {
    requestApp(WEB_TO_APP.CLOSE_POPUP, {});
}

// ─── 네이티브 지도 브릿지 ───

/** 네이티브 지도 요청/응답에 사용할 콜백 레지스트리 */
const nativeCallbacks: Record<string, (data: any) => void> = {};

/** 고유 requestId 생성 */
let requestSeq = 0;
const generateRequestId = () => `req_${Date.now()}_${++requestSeq}`;

/** 네이티브 콜백 등록 (useWebview에서 응답 수신 시 호출) */
export const resolveNativeCallback = (requestId: string, data: any) => {
    const cb = nativeCallbacks[requestId];
    if (cb) {
        cb(data);
        delete nativeCallbacks[requestId];
    }
};

/** 네이티브 환경인지 확인 */
export const isNativeApp = (): boolean => !!window.ReactNativeWebView;

/**
 * 네이티브 장소 검색 화면 열기
 * @returns Promise<PlaceInfo | null> 사용자가 장소를 선택하면 결과 반환, 취소 시 null
 */
export interface PlaceInfo {
    name: string;
    address: string;
    lat: number;
    lng: number;
}

export const openNativePlaceSearch = (options?: {
    currentLocation?: { lat: number; lng: number };
    initialQuery?: string;
    placeInfo?: PlaceInfo;
}): Promise<PlaceInfo | null> => {
    return new Promise((resolve) => {
        const requestId = generateRequestId();
        nativeCallbacks[requestId] = (data: any) => {
            resolve(data?.place || null);
        };
        requestApp(WEB_TO_APP.OPEN_PLACE_SEARCH, {
            requestId,
            ...options,
        });
    });
};

/**
 * 네이티브 장소 탐색 화면 열기 (해외 전용 — 추천장소 목록 + 검색 + 리뷰 + 선택)
 */
export const openNativePlaceExplore = (options: {
    places: Array<{ id: string; name: string; address: string; lat: number; lng: number; imageUrl?: string; rating?: number; categoryLabel?: string }>;
    center: { lat: number; lng: number };
    confirmButtonText?: string;
    /** 화면 제목 — 무엇을 고르는 중인지 (예: 집결지 고르기).
     *  안 주면 네이티브가 제목 줄을 그리지 않아 예전과 같습니다. */
    title?: string;
    apiUrl?: string;
    /** rev4 · 네이티브 지도 mode 전환 (hotel=숙박전용/attraction=관광/general=일반) */
    mode?: 'hotel' | 'attraction' | 'general';
}): Promise<PlaceInfo | null> => {
    return new Promise((resolve) => {
        const requestId = generateRequestId();
        nativeCallbacks[requestId] = (data: any) => {
            resolve(data?.place || null);
        };
        requestApp(WEB_TO_APP.OPEN_PLACE_EXPLORE, {
            requestId,
            ...options,
        });
    });
};

/**
 * 여행 모임 — 숙박/장소 선택용 네이티브 Google Maps 화면 열기.
 *
 * 기존 `openNativePlaceSearch` (한국 전용 카카오/구글 검색) 와 달리 국가 제한이 없고,
 * 네이티브 Google Places Autocomplete + Details API 를 사용한다.
 * 해외 여행 숙박 선택 등 "오픈소스(Leaflet) 지도" 대체 용도로 사용.
 *
 * @returns 선택된 장소 정보 또는 취소 시 null
 */
export interface GooglePlaceInfo extends PlaceInfo {
    placeId?: string;
}

export const openNativeGooglePlaceSearch = (options?: {
    initialQuery?: string;
    initialLocation?: { lat: number; lng: number };
    confirmButtonText?: string;
    placeholder?: string;
    /** 화면 제목 — 무엇을 고르는 중인지 (예: 숙소 고르기). 안 주면 기본 제목. */
    title?: string;
}): Promise<GooglePlaceInfo | null> => {
    return new Promise((resolve) => {
        if (!isNativeApp()) {
            resolve(null);
            return;
        }
        const requestId = generateRequestId();
        nativeCallbacks[requestId] = (data: any) => {
            resolve(data?.place || null);
        };
        requestApp(WEB_TO_APP.OPEN_GOOGLE_PLACE_SEARCH, {
            requestId,
            ...options,
        });
    });
};

/**
 * 네이티브 지도 보기 (단순 위치 표시)
 */
export const openNativeMapView = (place: PlaceInfo) => {
    /* lat/lng 을 반드시 Number 로.
       react-native-maps 는 문자열 좌표를 받으면 UnexpectedNativeTypeException 으로
       앱을 죽입니다 (openNativeRealtimeLocation 이 같은 이유로 이미 이렇게 합니다).
       호출부가 늘 숫자를 준다고 믿지 않고 보내는 자리에서 맞춥니다. */
    requestApp(WEB_TO_APP.OPEN_MAP_VIEW, {
        ...place,
        lat: Number(place.lat),
        lng: Number(place.lng),
    });
};

/**
 * 네이티브 실시간 위치 추적 화면 열기
 */
export const openNativeRealtimeLocation = (data: {
    meetingId: string;
    destination: PlaceInfo;
    mode?: 'realtime' | 'directions'; // realtime: 실시간 위치, directions: 길찾기
}) => {
    // destination.lat/lng 을 반드시 Number 로. 백엔드 응답에 &quot;37.4602&quot; 같은 문자열이 그대로
    // 담긴 채 여기까지 오는 경로가 있어 rn-maps native 가 String → double 캐스팅에서
    // UnexpectedNativeTypeException 을 던지고 앱이 crash 되던 회귀 방지.
    const safeDest = {
        ...data.destination,
        lat: Number(data.destination.lat),
        lng: Number(data.destination.lng),
    };
    requestApp(WEB_TO_APP.OPEN_REALTIME_LOCATION, {
        ...data,
        destination: safeDest,
        mode: data.mode || 'realtime',
    });
};

/**
 * 네이티브에 현재 위치 요청
 */
export const getNativeCurrentLocation = (): Promise<{ lat: number; lng: number } | null> => {
    return new Promise((resolve) => {
        const requestId = generateRequestId();
        let resolved = false;

        nativeCallbacks[requestId] = (data: any) => {
            if (!resolved) {
                resolved = true;
                resolve(data?.location || null);
            }
        };

        requestApp(WEB_TO_APP.GET_CURRENT_LOCATION, { requestId });

        // 10초 타임아웃: 네이티브 GPS 응답 대기 (네이티브 내부 8초 timeout 고려)
        setTimeout(() => {
            if (!resolved) {
                resolved = true;
                delete nativeCallbacks[requestId];
                console.log('[Location] 네이티브 응답 타임아웃 (10초)');
                resolve(null);
            }
        }, 10000);
    });
};

/**
 * 네이티브에 토큰 갱신을 요청한다.
 *
 * 앱 안에서는 네이티브와 웹뷰가 같은 refresh 토큰을 들고 있는데, 서버는 갱신
 * 즉시 옛 토큰을 지운다. 웹뷰가 스스로 /auth/refresh 를 부르면 네이티브가 든
 * 토큰이 그 순간 죽고, 네이티브는 다음 갱신에서 4xx 를 받아 로그아웃해 버린다.
 * 그래서 갱신은 네이티브 한 곳에서만 하고 웹뷰는 결과만 받는다.
 *
 * @returns 새 accessToken. 실패하거나 구버전 앱이라 응답이 없으면 null
 *          (null 이면 호출자가 예전처럼 직접 갱신을 시도한다)
 */
/* 이 브릿지가 없는 구버전 앱인지 판단한다.
   ⚠️ 한 번 무응답이었다고 바로 포기하면 안 된다. 네이티브 갱신은 회전 경합 대기
   (최대 2.5초) + 네트워크 왕복이 겹치면 3초를 넘길 수 있어, 정상 동작 중에도
   타임아웃이 날 수 있다. 그때 웹이 직접 /auth/refresh 를 치면 회전형 토큰이
   폐기되어 네이티브가 다음 갱신에서 4xx → 로그아웃된다(로그인 풀림의 원인).
   그래서 연속 실패가 THRESHOLD 회 쌓였을 때만 "구버전 앱" 으로 확정하고,
   한 번이라도 응답이 오면 카운터를 리셋한다. */
const NATIVE_REFRESH_TIMEOUT_MS = 6000;   // 네이티브 최악 지연(3초+) 을 덮는 값
const NATIVE_REFRESH_FAIL_THRESHOLD = 3;
let nativeRefreshTimeoutCount = 0;
let nativeRefreshUnavailable = false;

/**
 * 네이티브 갱신 브릿지를 아직 신뢰할 수 있는가.
 * true 면 웹이 직접 /auth/refresh 를 치면 안 된다(회전형 토큰이 폐기되어 로그아웃된다).
 * 단 네이티브가 "줄 토큰이 없다" 고 답한 경우는 예외다 — 지킬 토큰이 없으므로
 * 그때는 웹이 직접 갱신해도 된다. 판단은 호출자가 answered 로 한다.
 */
export const isNativeRefreshAvailable = (): boolean => isNativeApp() && !nativeRefreshUnavailable;

/**
 * 갱신 위임 결과.
 *
 * answered 가 왜 필요한가 — 예전에는 둘 다 그냥 null 이었다.
 *   ① 네이티브가 응답조차 안 함(구버전 앱/지연)
 *   ② 네이티브가 응답했는데 줄 토큰이 없음
 * 호출자는 이걸 구분하지 못해 ② 에서도 직접 갱신을 자제했고, 네이티브 저장소가
 * 빈 기기(로그아웃됐는데 웹뷰에만 토큰이 남은 상태)에서는 세션이 영구히 죽은 채
 * 로그인처럼 보이며 모든 요청이 401 로 끝났다. 실기기(노트10)에서 확인한 회귀다.
 */
export type NativeRefreshResult = {
    /** 네이티브가 응답했는가. false 면 무응답(구버전 앱이거나 지연) */
    answered: boolean;
    /** 네이티브가 준 accessToken. 없으면 null */
    accessToken: string | null;
};

export const requestNativeTokenRefresh = (): Promise<NativeRefreshResult> => {
    if (nativeRefreshUnavailable) return Promise.resolve({ answered: false, accessToken: null });

    return new Promise((resolve) => {
        const requestId = generateRequestId();
        let resolved = false;

        nativeCallbacks[requestId] = (data: any) => {
            if (resolved) return;
            resolved = true;
            nativeRefreshTimeoutCount = 0;   // 응답이 왔으면 브릿지는 살아 있다
            // 네이티브가 갱신한 토큰을 웹뷰 저장소에도 반영해 다음 요청부터 바로 쓰이게 한다.
            // 단, 방금 로그아웃했으면 받지 않는다 — 로그아웃을 무효화하기 때문.
            // auth 를 정적으로 가져오면 순환이라 여기서만 지연 require 한다.
            try {
                const { isJustLoggedOut } = require('./utils/auth');
                // 방금 로그아웃했으면 answered 를 세우지 않는다. 세우면 호출자가
                // "네이티브에 토큰이 없구나" 로 읽고 웹 refresh 토큰으로 직접 갱신해
                // 로그아웃을 되살린다.
                if (isJustLoggedOut?.()) { resolve({ answered: false, accessToken: null }); return; }
            } catch { /* auth 모듈 없으면 그냥 진행 */ }
            try {
                if (data?.accessToken) localStorage.setItem('accessToken', data.accessToken);
                if (data?.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
            } catch { /* storage 실패 무시 */ }
            resolve({ answered: true, accessToken: data?.accessToken || null });
        };

        requestApp(WEB_TO_APP.REQUEST_TOKEN_REFRESH, { requestId });

        // 구버전 앱에는 이 액션이 없다. 응답이 없으면 호출자가 직접 갱신하도록 null 로 푼다.
        setTimeout(() => {
            if (resolved) return;
            resolved = true;
            delete nativeCallbacks[requestId];
            nativeRefreshTimeoutCount += 1;
            if (nativeRefreshTimeoutCount >= NATIVE_REFRESH_FAIL_THRESHOLD) {
                nativeRefreshUnavailable = true;
                console.warn(
                    `[refresh] 네이티브 무응답 ${nativeRefreshTimeoutCount}회 — 구버전 앱으로 보고 이후 웹에서 직접 갱신`,
                );
            } else {
                console.warn(
                    `[refresh] 네이티브 응답 지연(${nativeRefreshTimeoutCount}/${NATIVE_REFRESH_FAIL_THRESHOLD}) — 다음엔 다시 네이티브에 위임`,
                );
            }
            resolve({ answered: false, accessToken: null });
        }, NATIVE_REFRESH_TIMEOUT_MS);
    });
};

/**
 * 사진을 기기 사진첩에 저장해 달라고 요청합니다.
 *
 * 웹에서 직접 못 하는 이유 — CDN 이 CORS 를 열어 주지 않아 이미지 바이트를
 * 읽을 수 없고(실기기 확인: Failed to fetch), 이 웹뷰에는 navigator.share 도
 * 없습니다. 네이티브에는 그런 제약이 없습니다.
 *
 * 이 메시지를 모르는 구버전 앱은 답하지 않습니다. 그때는 timedOut 으로
 * 돌아오므로, 부르는 쪽이 "업데이트가 필요하다" 고 알려 줄 수 있습니다.
 */
export interface SaveImageResult {
    ok: boolean;
    /** 앱이 이 기능을 모르는 경우(구버전) */
    timedOut: boolean;
    error?: string;
}

/**
 * 앱에 일을 시키고 결과를 기다립니다.
 *
 * 앱은 요청을 받자마자 phase:'started' 를 보냅니다. 그 신호가 짧은 시간 안에
 * 오지 않으면 이 메시지를 모르는 구버전입니다 — 20초를 기다릴 이유가 없습니다.
 * 신호가 오면 실제 작업(내려받기·저장·공유 시트)이 끝날 때까지 넉넉히 줍니다.
 */
const askApp = (
    type: string,
    payload: Record<string, unknown>,
): Promise<SaveImageResult> => {
    return new Promise((resolve) => {
        const requestId = generateRequestId();
        let done = false;
        let started = false;
        let ackTimer = 0;
        let workTimer = 0;

        const finish = (r: SaveImageResult) => {
            if (done) return;
            done = true;
            window.clearTimeout(ackTimer);
            window.clearTimeout(workTimer);
            delete nativeCallbacks[requestId];
            resolve(r);
        };

        nativeCallbacks[requestId] = (data: any) => {
            if (data?.phase === 'started') {
                started = true;
                window.clearTimeout(ackTimer);
                /* 공유 시트는 사용자가 고를 때까지 열려 있습니다 — 넉넉히 둡니다 */
                workTimer = window.setTimeout(
                    () => finish({ ok: false, timedOut: false, error: 'TIMEOUT' }), 180000);
                /* 아직 안 끝났으니 콜백을 지우지 않습니다 */
                nativeCallbacks[requestId] = (d: any) => {
                    if (d?.phase === 'started') return;
                    finish({ ok: !!d?.ok, timedOut: false, error: d?.error });
                };
                return;
            }
            finish({ ok: !!data?.ok, timedOut: false, error: data?.error });
        };

        requestApp(type, { requestId, ...payload });

        // 시작 신호가 이 안에 안 오면 앱이 이 기능을 모르는 것입니다
        ackTimer = window.setTimeout(() => {
            if (started) return;
            finish({ ok: false, timedOut: true });
        }, 2500);
    });
};

export const saveNativeImage = (url: string): Promise<SaveImageResult> =>
    askApp(WEB_TO_APP.SAVE_IMAGE, { url });

/** 사진 자체를 공유합니다 — 주소가 아니라 파일이 갑니다 */
export const shareNativeImage = (url: string, message?: string): Promise<SaveImageResult> =>
    askApp(WEB_TO_APP.SHARE_IMAGE, { url, message });

/**
 * 네이티브 이미지 선택
 * - 기본 PICK_IMAGE 로 요청하면서 source 파라미터 동봉 (네이티브가 구분 처리하거나 기본 UX 사용)
 * - 네이티브가 source를 지원할 경우:
 *   - source='camera'  → 카메라만 열기
 *   - source='gallery' → 갤러리만 열기
 */
export interface NativeImage {
    uri: string;
    base64?: string;
    filename?: string;
    fileName?: string;
    mime?: string;
    type?: string;
}

export interface NativeImagePick {
    image: NativeImage | null;
    /** 사용자가 그만둔 경우 — 실패가 아니므로 아무 말도 하지 않아야 합니다 */
    cancelled: boolean;
    /** 네이티브가 60초 안에 답하지 않은 경우 */
    timedOut: boolean;
    /** 네이티브가 준 오류 코드 */
    error?: string;
}

/**
 * 네이티브 이미지 선택 — 결과를 그대로 돌려줍니다.
 *
 * pickNativeImage 는 실패를 null 하나로 뭉갭니다. 취소했는지, 네이티브가 답을
 * 안 했는지, 사진을 못 읽었는지 구분할 수 없어 사용자에게 아무 말도 못 하고
 * 우리도 어디서 끊겼는지 알 수 없었습니다.
 */
export const pickNativeImageDetailed = (source?: 'camera' | 'gallery'): Promise<NativeImagePick> => {
    return new Promise((resolve) => {
        const requestId = generateRequestId();
        let resolved = false;
        nativeCallbacks[requestId] = (data: any) => {
            if (resolved) return;
            resolved = true;
            resolve({
                image: data?.image || null,
                cancelled: !!data?.cancelled,
                timedOut: false,
                error: data?.error,
            });
        };
        requestApp(WEB_TO_APP.PICK_IMAGE, { requestId, source });
        // 네이티브가 응답을 안 주는 경우 대비 — 60초 타임아웃
        setTimeout(() => {
            if (resolved) return;
            resolved = true;
            delete nativeCallbacks[requestId];
            console.warn('[pickNativeImage] timeout — native did not respond');
            resolve({ image: null, cancelled: false, timedOut: true });
        }, 60000);
    });
};

/**
 * 네이티브 이미지 선택
 * - 기존 사용처(채팅·프로필)를 위해 남겨 둡니다. 실패 이유가 필요하면
 *   pickNativeImageDetailed 를 쓰십시오.
 */
export const pickNativeImage = (source?: 'camera' | 'gallery'): Promise<NativeImage | null> =>
    pickNativeImageDetailed(source).then(r => r.image);

// 네이티브에서 받은 이벤트 가공
export const msgData = (event: MessageEvent) => {
    const originData = event?.data;
    if (!originData) return { type: undefined, data: undefined };

    let response;
    // 네이티브가 JSON 문자열 또는 객체 리터럴로 전달 — 둘 다 처리
    if (typeof originData === 'string') {
        try {
            response = JSON.parse(originData);
        } catch (error) {
            return { type: undefined, data: undefined };
        }
    } else if (typeof originData === 'object') {
        response = originData;
    } else {
        return { type: undefined, data: undefined };
    }

    const type = (response?.type as string)?.toUpperCase();
    let data = response.data;
    // data가 문자열이면 한 번 더 파싱 시도 (네이티브가 이중 인코딩한 경우)
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        } catch (error) {
            // 파싱 실패 시 원본 문자열 유지
        }
    }

    return { type, data };
}

/**
 * 네이티브에 모임 위치 추적 시작 요청
 * 위치공유 ON + 모임 스케줄이 있을 때 호출
 * attending/sharing 는 네이티브 defense-in-depth 용 플래그 — 네이티브가 시간
 * 범위 + 이 플래그를 조합해 측위 실행 여부를 2차 검증함.
 *
 * meetingLat/meetingLon — 네이티브의 Hybrid accuracy 로직 anchor 좌표.
 * 모임 좌표 기준 80m 초과 시 GPS High, 60m 이내 5회 연속 시 WiFi Medium 으로 자동 전환.
 * 이 좌표를 안 보내면 anchor null → 항상 Medium 고정 → 야외 GPS 정확도 손실.
 */
export const setNativeMeetingSchedule = (
    meetingId: string,
    startTime: number,
    endTime: number,
    opts?: {
        attending?: boolean;
        sharing?: boolean;
        meetingLat?: number;
        meetingLon?: number;
    },
) => {
    requestApp(WEB_TO_APP.SET_MEETING_SCHEDULE, {
        meetingId,
        startTime,
        endTime,
        // 기본값 true — 호출 시점에 이미 참석+공유 ON 확인된 상태가 대부분
        attending: opts?.attending ?? true,
        sharing: opts?.sharing ?? true,
        meetingLat: Number.isFinite(opts?.meetingLat) ? opts?.meetingLat : undefined,
        meetingLon: Number.isFinite(opts?.meetingLon) ? opts?.meetingLon : undefined,
    });
};

/**
 * 네이티브에 모임 위치 추적 중지 요청
 * 위치공유 OFF 시 호출
 */
/**
 * 네이티브에서 "특정 모임" 의 추적 스케줄만 제거한다.
 * 위치공유 OFF·참석 취소·귀가 종료처럼 한 모임에만 해당하는 경우는 반드시 이걸 쓴다.
 */
export const removeNativeMeetingSchedule = (meetingId: string) => {
    if (!meetingId) return;
    requestApp(WEB_TO_APP.REMOVE_MEETING_SCHEDULE, { meetingId });
};

/**
 * 네이티브의 "모든" 추적 스케줄을 제거한다.
 * ⚠️ 전체 삭제라 참여 중인 다른 모임 추적까지 함께 끊긴다.
 *    로그아웃/탈퇴처럼 전부 지워야 하는 경우에만 쓸 것.
 *    한 모임만 끄려면 removeNativeMeetingSchedule(meetingId) 을 쓴다.
 */
export const clearNativeMeetingSchedule = () => {
    requestApp(WEB_TO_APP.CLEAR_MEETING_SCHEDULE, {});
};

/**
 * 서버 응답(목록/상세/생성 등 형태가 제각각)에서 추적 스케줄 등록에 필요한 값을 뽑는다.
 *
 * 등록 정책: **실제 모임 시작 시각을 그대로 넘긴다.**
 *   네이티브가 `start - trackingStartOffset(기본 1시간)` 부터 자동으로 추적을 켜므로
 *   웹이 시작 시각을 앞당길 필요가 없다. 앞당기면 네이티브에 모임 시각 정보가 사라져
 *   추적 구간이 부정확해진다.
 *
 * @returns 등록 대상이 아니면 null (시작시각 없음 / 이미 종료)
 */
export const resolveMeetingSchedule = (
    m: any,
): { startTs: number; endTs: number; lat?: number; lng?: number } | null => {
    if (!m) return null;

    const startRaw =
        m.scheduleStartDateTime ?? m.schedule?.startDatetime ?? m.startDatetime ?? m.startTime;
    if (!startRaw) return null;
    const startTs = typeof startRaw === 'number' ? startRaw : new Date(startRaw).getTime();
    if (!Number.isFinite(startTs)) return null;

    const endRaw =
        m.scheduleEndDateTime ?? m.schedule?.endDatetime ?? m.endDatetime ?? m.endTime;
    const parsedEnd = endRaw
        ? (typeof endRaw === 'number' ? endRaw : new Date(endRaw).getTime())
        : NaN;
    const endTs = Number.isFinite(parsedEnd) ? parsedEnd : startTs + 3 * 60 * 60 * 1000;

    if (endTs <= Date.now()) return null; // 이미 종료된 모임은 등록하지 않는다
    if (startTs >= endTs) return null;    // 네이티브가 거부하는 구간

    const latRaw = m.latitude ?? m.lat ?? m.meetingLat;
    const lngRaw = m.longitude ?? m.lng ?? m.lon ?? m.meetingLon ?? m.meetingLng;
    const lat = Number(latRaw);
    const lng = Number(lngRaw);

    return {
        startTs,
        endTs,
        lat: Number.isFinite(lat) ? lat : undefined,
        lng: Number.isFinite(lng) ? lng : undefined,
    };
};

/**
 * 서버 응답 객체 하나로 추적 스케줄을 등록한다(정규화 + 등록을 한 번에).
 * 등록 대상이 아니면 아무것도 하지 않고 false 를 반환한다.
 */
export const syncNativeMeetingSchedule = (
    meetingId: string,
    meeting: any,
    opts?: { attending?: boolean; sharing?: boolean },
): boolean => {
    if (!isNativeApp() || !meetingId) return false;
    const sched = resolveMeetingSchedule(meeting);
    if (!sched) return false;
    setNativeMeetingSchedule(meetingId, sched.startTs, sched.endTs, {
        ...opts,
        meetingLat: sched.lat,
        meetingLon: sched.lng,
    });
    return true;
};

// ─── 귀가 도우미 (Safe Return) 브릿지 ───

export interface SafeReturnSessionBridgePayload {
    sessionId: number;
    travelerUserNo: number;
    destLat: number;
    destLng: number;
    destRadiusM: number;
    expiresAt: number; // ms timestamp
    role?: 'TRAVELER' | 'WATCHER';
}

/**
 * 네이티브에 Safe Return 세션 등록 요청.
 * traveler 단말에서 세션 시작/진행 중에 호출하면 모임 종료와 무관하게 BG location 유지.
 */
export const setNativeSafeReturnSession = (data: SafeReturnSessionBridgePayload): void => {
    if (!isNativeApp()) return;
    requestApp(WEB_TO_APP.SET_NATIVE_SAFE_RETURN_SESSION, {
        sessionId: data.sessionId,
        travelerUserNo: data.travelerUserNo,
        destLat: data.destLat,
        destLng: data.destLng,
        destRadiusM: data.destRadiusM,
        expiresAt: data.expiresAt,
        role: data.role || 'TRAVELER',
    });
};

/**
 * 네이티브에서 Safe Return 세션 제거 요청.
 * 세션이 ARRIVED / EXPIRED / CANCELLED / DEAD_MAN 상태로 종료된 순간에만 호출해야 한다
 * (언마운트만으로는 호출하지 않음 — BG tracking 유지 목적).
 */
export const clearNativeSafeReturnSession = (sessionId: number): void => {
    if (!isNativeApp()) return;
    requestApp(WEB_TO_APP.CLEAR_NATIVE_SAFE_RETURN_SESSION, { sessionId });
};
